import { jsx as t, Fragment as i } from "react/jsx-runtime";
import { Chip as p } from "@mui/material";
import { l as a, m as l } from "../../index-DVHhaa_b.js";
const f = ({ resources: n }) => {
  const m = n == null ? void 0 : n.filter((o) => o.ResourceType === 1);
  return !m || m.length === 0 ? null : /* @__PURE__ */ t(i, { children: m.map((o) => /* @__PURE__ */ t(p, { size: "small", label: o.Description, icon: /* @__PURE__ */ t(a, { iconType: l.Location }) }, o.Id)) });
};
export {
  f as EventRooms
};
//# sourceMappingURL=EventRooms.js.map
